import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from '@core/core.module';
import { HTTPReqResInterceptor } from '@core/services/http-req-res.interceptor';
import { environment } from '@env';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { DynamicModule } from 'ng-dynamic-component';
import { ChartModule } from '@syncfusion/ej2-angular-charts';
import { authConfig } from './auth.config';
import { AuthConfig, OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import { StatehandlerService, StatehandlerServiceImpl } from '@core/services/statehandler.service';
import {
  StatehandlerProcessorService,
  StatehandlerProcessorServiceImpl,
} from '@core/services/statehandler-processor.service';
import { StorageService } from '@core/services/storage.service';
import { MatSelectModule } from '@angular/material/select';
import { SpinnerInterceptor } from '@core/services/spinner.interceptor';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MatChipsModule } from '@angular/material/chips';
import { ApiModule, Configuration, ConfigurationParameters } from '@core/mira-service-api';
// import { DockerRoutingModule } from './features/after-login/dockers/docker-routing.module';
const configurationFactory = () => {
  const configParams: ConfigurationParameters = {
    basePath: environment.baseurl,
  };
  return new Configuration(configParams);
};

const stateHandlerFn = (stateHandler: StatehandlerService) => {
  return () => {
    return stateHandler.initStateHandler();
  };
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    HttpClientModule,
    LoadingBarRouterModule,
    MatIconModule,
    ReactiveFormsModule,
    ChartModule,
    ApiModule.forRoot(configurationFactory),
    ToastrModule.forRoot({
      maxOpened: 1,
      progressBar: true,
      progressAnimation: 'decreasing',
    }),
    MatMenuModule,
    MatDialogModule,
    DynamicModule,
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [environment.baseurl],
        sendAccessToken: true,
      },
    }),
    MatSelectModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatInputModule,
    MatChipsModule,
    // DockerRoutingModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: stateHandlerFn,
      multi: true,
      deps: [StatehandlerService],
    },
    {
      provide: AuthConfig,
      useValue: authConfig,
    },
    {
      provide: StatehandlerProcessorService,
      useClass: StatehandlerProcessorServiceImpl,
    },
    {
      provide: StatehandlerService,
      useClass: StatehandlerServiceImpl,
    },
    {
      provide: OAuthStorage,
      useClass: StorageService,
    },
    {
      provide: APP_BASE_HREF,
      useValue: '/',
    },
    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HTTPReqResInterceptor, multi: true },
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
